import React from "react";
import "../css/resetPasswordForm.css"
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";

const baseUrl = "https://petme.onrender.com/user";

function ResetPasswordForm() {

  const navigate = useNavigate();
  const location = useLocation();
  const [invalidUser, setInvalidUser] = useState("");
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [newPassword, setNewPassword] = useState({
    password: "",
    confirmPassword: ""
  });
  const { token, id } = queryString.parse(location.search);

  const verifyToken = async () => {
    try {
      await axios.get(`${baseUrl}/verify-token?token=${token}&id=${id}`);
      setBusy(false);
    } catch (error) {
      if (error?.response?.data) {
        const { data } = error.response;
        if (!data.success) return setInvalidUser(data.error);
      }
      console.log(error);
    }
  };

  useEffect(() => {
    verifyToken();
  }, []);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setNewPassword({ ...newPassword, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { password, confirmPassword } = newPassword;

    if (password.trim().length < 8 || password.trim().length > 20) {
      return setError("Password must be 8 to 20 characters long!");
    }

    if (password !== confirmPassword) {
      return setError("Password must match the confirm password");
    }

    try {
      setBusy(true);
      await axios.post(`${baseUrl}/reset-password?token=${token}&id=${id}`, {
        password
      });
      setBusy(false);
      setSuccess(true);
      navigate("/login")

    } catch (error) {
      setBusy(false);
      if (error?.response?.data) {
        const { data } = error.response;
        if (!data.success) return setError(data.error);
      }
      console.log(error);
    }
  };

  if (success) {
    return (
      <div className="resetPasswordForm-successfulMsgDiv">
        <h1 className="resetPasswordForm-successfulMsg">Password reset successfully</h1>
      </div>
    );
  }

  if (invalidUser) {
    return (
      <div className="resetPasswordForm-invalidMsgDiv">
        <h1 className="resetPasswordForm-invalidfulMsg">{invalidUser}</h1>
      </div>
    );
  }

  if (busy) {
    return (
      <div className="resetPasswordForm-verifyingMsgDiv">
        <h1 className="resetPasswordForm-verifyingMsg">Verifying reset token. Please wait...</h1>
      </div>
    );
  }


  return (

    <div>
      <div className="resetPasswordForm-bg_img"></div>
      <div className="resetPasswordForm-div">
        <div className="resetPasswordForm-content">
          <h2 className="resetPasswordForm-heading">Reset Password</h2>
          <p className="resetPasswordForm-msg">Set the new password for your account so you can login and access all the features.</p>
          <div className="resetPasswordForm-inputBoxDiv">
            <input id="password" type="password" name="password" class="resetPasswordForm-box" placeholder="password" onChange={handleChange} /><br />
            <input id="confirmPassword" type="password" name="confirmPassword" class="resetPasswordForm-box" placeholder="confirm password" onChange={handleChange} /><br />
            {error && <p>{error}</p>}
          </div>
          <NavLink className="resetPasswordForm-Navlink" to=""><button type="button" className="resetPasswordForm-Btn" onClick={handleSubmit}>RESET PASSWORD</button></NavLink>
        </div>
      </div>
    </div>

  );
}


export default ResetPasswordForm